














import Vue from 'vue';

export interface Step {
  id: number;
  title: string;
  done: boolean;
  disabled: boolean;
}

export default Vue.extend({
  name: 'StepNavigation',
  props: {
    stepInfo: {
      type: Array as () => Step[],
      required: true,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    stepClass(step: Step): any[] {
      return [
        'step',
        'flex-fill',
        { active: step.id === this.currentStep },
        { done: step.id < this.currentStep },
        { disabled: step.disabled || this.disabled },
      ];
    },
    setStep(step: Step) {
      if (!step.disabled) {
        this.$emit('setStep', step.id);
      }
    },
  },
});
